import { schemaTypes } from '../../../constants/constants'
import ReportAPIs from '../../../APIs/ReportAPIs';
import { JSONToCSVConvertor } from '../../../helpers/helperFunctions'
import _ from 'lodash';
import moment from 'moment';
import { changeVehicle } from './historyReport/historyReport';
import {startLiveData} from '../../../components/ReportWindow/ReportWindow'
window.downloadCanData = []

export const dateFormat = "DD-MMM-YYYY HH:mm";
const downloadReport = (schema) => {
    if (window.downloadCanData){
        window.downloadCanData.map((data, index)=>{
            if (data.uid || data.uid == 0){
                delete data.uid
            }
        })
        JSONToCSVConvertor(window.downloadCanData, "CAN_Snapshot" + '_' + window.selectedVehicles[0].name + '_' + moment(Date.now()).format('DD_MM_YYYY HH:mm:ss'), false)
    }
};

let meta = [{ "battery_voltage": 'V' },
 { "current": 'A' },
 { "soc": '%' },
 { "controller_temperature": '°C' }, 
 { "motor_temperature": '°C' },
 { "speed":'Kmph'},
 { "battery_current":'A'},
 { "odometer": 'km' },
 { "soh":'%'},
 { "battery_temperature":'°C'},
 { "engine_speed": 'rpm'},
 { "vehicle_speed":'kmph'}
]

export const bmsStateMap = [
    {key:0, value:"Reset" },
    {key:1, value:"Discharging" },
    {key:2, value:"Discharged" },
    {key:3, value:"Charging" },
    {key:4, value:"Charged" },
    {key:5, value:"State fault (Ign-off)" },
    {key:6, value:"Over/Under voltage" },
    {key:7, value:"Short circuit (Fault SC)" },
    {key:8, value:"Over/Under temperature" },
    {key:9, value:"Mosfet Fail" },
    {key:10, value:"Shutdown" },
    {key:11, value:"Thermal Runaway" },
    {key:12, value:"Charger Authentication Fail (Fault UT)" },
    {key:13, value:"Pack Delta High" },
    {key:14, value:"Over Current (Fauly OC)" },
]
const packCurrentStateMap = {
    1: "Charging",
    2: "Discharging",
    3: "Normal",
    4: "Ideal",
    5: "Current Sleep",
    6: "Regen",
  };
  
  const bmsPowerModeMap = {
    0: "active_mode",
    1: "sleep_mode",
    2: "deepsleep_mode   ",
    3: "sleep_time_wakeup_mode",
  };

  const chargerstate={
    0: "Ideal",
    1: "Charging Battery",
    2: "stand-by",
    3: "battery failure",
    4: "charger failure"
  }

  const cc_cv_state_of_charger={
    0 : "cc_state",
    1 : "cv_state"
  }

export const faultMap = [
    { key: 0, value: "No fault" },
    { key: 1, value: "OverPackVoltageFault" },
    { key: 2, value: "OverPackVoltage" },
    { key: 3, value: "UnderPackVoltageFault" },
    { key: 4, value: "OverOCD1Current" },
    { key: 5, value: "OverOCD2Current" },
    { key: 6, value: "OverChargeCurrent" },
    { key: 7, value: "OverDisChargeCurrent" },
    { key: 8, value: "ShortCircuit" },
    { key: 9, value: "CellOpenWireFault" },
    { key: 10, value: "VoltageReferenceFault" },
    { key: 11, value: "VoltageRegulatorFault" },
    { key: 12, value: "TemperatureMultiplexerError" },
    { key: 13, value: "UnderTempFault" },
    { key: 14, value: "PDUOverTempFault" },
    { key: 15, value: "OscillatorFault" },
    { key: 16, value: "WatchdogTimeoutFault" },
    { key: 17, value: "UnderCellVoltageFault" },
    { key: 18, value: "OverCellVoltageFault" },
    { key: 19, value: "OpenWireFault" },
    { key: 20, value: "OverTempFault" },
    { key: 21, value: "CellUnBalPro" },
    { key: 22, value: "SCDLatchHigh" },
    { key: 23, value: "SPI Communication Fault" },
    { key: 24, value: "I2C Communication Fault" },
    { key: 25, value: "MCU Reset Fault" },
    { key: 26, value: "Data CRC Error Fault" },
    { key: 27, value: "Data Ready Fault" },
    { key: 28, value: "ChargerAuthenticationFailed" },
    { key: 29, value: "ThermalRunawayDueToTemperature" },
    { key: 30, value: "ThermalRunawayDueToVoltage" },
    { key: 31, value: "MOSFET_DriveVoltageFault" },
    { key: 32, value: "ReserveConditionReached" },
    { key: 33, value: "BatteryEmptyReached" },
    { key: 34, value: "BatteryFullChargedReached" },
    { key: 35, value: "WeldCheckFault" },
    { key: 36, value: "FuseBurnFault" },
    { key: 37, value: "PCU_OverTempFault" },
    { key: 38, value: "CelltemperatureImbalanceFault" },
    { key: 39, value: "PrechargeComplete_Fault" },
    { key: 40, value: "BatteryDeadFaultDueToCellOrTemp" },
    { key: 41, value: "EnergyDisburseComplete" },
    { key: 42, value: "HardCellOverVoltageProtection" },
    { key: 43, value: "HardCellUnderVoltageProtection" },
    { key: 44, value: "LOW_SOH_Protection" },
];
const getAllVehiceData = (schema, data, store) =>{
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    const auth = window.getAuth();
    let vehicleno = []
    if(window.downloadForAll){
        for (let idx in window.vehicleMap){
            vehicleno.push(window.vehicleMap[idx].vehicleno)
        }   
    }else if(window.selectedGroup){
        let vehicles = window.selectedGroup.vehicles
         for (let idx in vehicles){
            vehicleno.push(vehicles[idx].vehicleno)
        }   
    }
    if(!vehicleno.length){
        window.setReportWindowTabBusy(schema, false);
        store.dispatch({
            type: "ADD_INTOAST",
            data: {
              name: "No vehicle found.",
              content: "No vehicle found. Please select different group or select 'All vehicles' from dropdown",
              createAt: Date.now(),
              autoClose: 8000,
              showError:true
            },
          });
        return
    }
    let body = {
        "token": auth.token,
        "vehicleno": vehicleno
    }
    if(window.showNoGpsFixData === true){
        body.fixqfilter = false
    }
    const handleFailure = () => {
        window.setReportWindowTabBusy(schema, false);
        console.log("failed")
    }
    const handleSuccess = (resp) => {
        let header = [];
        window.CANALL = []
        let emptyObjArr = []
        for (let i in resp) {
            for (let j in resp[i]) {
                if (!header.includes(j)) {
                    header.push(j)
                }
            }
        }

        for (let i in resp) {
            if (Object.keys(resp[i]).length){
            let obj = {}
            obj["vehicleno"] = i
            header.map((key, index) => {
                if (resp[i][key]) {
                    obj[key + '-Time'] = moment(resp[i][key].timestamp).format('DD-MM-YYYY  HH:mm:ss')
                    let unit = ''
                    meta.map((data, index)=>{
                        if (Object.keys(data)[0] == key){
                            unit = Object.values(data)[0]
                        }
                    })
                    // console.log("resp[i][key].value",i,key,resp[i][key].value)

                    let value = null
                    if(typeof(resp[i][key].value) === 'number' && !Number.isInteger(resp[i][key].value)){
                        value = parseFloat((resp[i][key].value).toFixed(2))
                    }else value = resp[i][key].value
                    if (unit){
                    obj[key + '-Value'+ '( '+unit+' )'] = value
                    }else{
                    obj[key + '-Value'] = value
                    }
                } else {
                    obj[key + '-Time'] = ''
                    obj[key + '-Value'] = ''
                }
            })
            window.CANALL.push(obj)
        }else{
            let emptyObj = {}
                emptyObj["vehicleno"] = i
                emptyObjArr.push(emptyObj)
        }
        }
        window.CANALL = [...window.CANALL, ...emptyObjArr]
        JSONToCSVConvertor(window.CANALL, "CAN Snapshot For " + (window.downloadForAll ? "All Vehicles" :  window.selectedGroup.name) + " " + moment(Date.now()).format('DD_MM_YYYY HH:mm:ss')
, false)
        window.setReportWindowTabBusy(schema, false);
    }

    ReportAPIs.getLatestCanData(body).then((resp) => {
        handleSuccess(resp);
    }, handleFailure)

}

export const getCanDataReport = (schema, data, store) => {
    // console.log("data",schema, data, store)
    let saveState = null;
    let tableStateData = null;
    // if(!data || !data.vehicle.length){
    //     store.dispatch({
    //       type: "ADD_INTOAST",
    //       data: {
    //         name: "Please select a vehicle",
    //         content: "Please select a vehicle",
    //         createAt: Date.now(),
    //         autoClose: 8000,
    //       },
    //     });
    //     return;
    //   }
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    window.renderCanTable = true
    const auth = window.getAuth();
    let vehicleno = []
    if(window.snaplive === true){
        vehicleno.push(window.canDataVehicle)
    }
    else{
        if(!data || !data.vehicle.length){
            store.dispatch({
              type: "ADD_INTOAST",
              data: {
                name: "Please select a vehicle",
                content: "Please select a vehicle",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
              },
            });
            return;
          }
        vehicleno.push(data.vehicle[0].data.vehicleno)
    }

    let body = {
        "token": auth.token,
        "vehicleno": vehicleno
    }

    const handleFailure  = () =>{
        window.canData = []
        window.downloadCanData = []
        window.setReportWindowTabBusy(schema, false);
        console.log("failed")
    }
    ReportAPIs.getLatestCanData(body).then((resp) => {
        handleSuccess(resp);
    }, handleFailure)

    const getBMSvalue = (value) => {
        let stateValue = ""
        for(let idx in bmsStateMap){
            if(bmsStateMap[idx].key === value){
                stateValue = bmsStateMap[idx].value
                break
            }
        }
        return stateValue
    }
    const getFaultValue = (value) => {
        let faultValue = ""
        for (let idx in faultMap) {
            if (faultMap[idx].key === value) {
                faultValue = faultMap[idx].value;
                break;
            }
        }
        return faultValue;
    }
    let fault_map = window.userInfo && window.userInfo.SELF && window.userInfo.SELF.fault_map ? true : false;
    const handleSuccess = (resp) => {
        window.canData = []
        window.downloadCanData = []
        // let toFixParams = ["cell_temperature_01","cell_temperature_02", "cell_temperature_03", "cell_temperature_04"]
        for(let idx in resp){
            let keys = Object.keys(resp[idx])
            keys.map((key,index)=>{
                let obj = {}
                let dData = {}
                obj.slno = index+1
                obj.vehicleno = idx
                obj.parameter = key
                dData.slno = index+1
                dData.vehicleno = idx
                dData.parameter = key
                let unit = ''
                meta.map((data, index) => {
                    if (Object.keys(data)[0] == key) {
                        unit = Object.values(data)[0]
                    }
                })
                // console.log(resp[idx][key].value)
                let rawValue = resp[idx][key].value
                let value = null


                if (fault_map && key === "pack_current_state") {
                    value =
                      packCurrentStateMap[rawValue] ??
                      rawValue ??
                      ""
                  }
                  
                  // ✅ bms_power_mode mapping
                  else if (fault_map && key === "bms_power_mode") {
                    value =
                      bmsPowerModeMap[rawValue] ??
                      rawValue ??
                      ""
                  }

                  else if (fault_map && key === "cc_cv_state_of_charger") {
                    value =
                    cc_cv_state_of_charger[rawValue] ??
                      rawValue ??
                      ""
                  }
                  else if (fault_map && key === "charger_state") {
                    value =
                    chargerstate[rawValue] ??
                      rawValue ??
                      ""
                  }
                  
                  // ✅ status mapping
                  else if (
                    key === "status" &&
                    window.selectedVehicles[0] &&
                    window.selectedVehicles[0].data.vehicleModel &&
                    window.selectedVehicles[0].data.vehicleModel.variant === "Lithion 500"
                  ) {
                    value = getBMSvalue(rawValue)
                  }
                  
                  // ✅ fault mapping
                  else if (key === "fault" && fault_map) {
                    value = getFaultValue(rawValue)
                  }
                  
                  // ✅ decimal handling
                  else if (typeof rawValue === 'number' && !Number.isInteger(rawValue)) {
                    value = parseFloat(rawValue.toFixed(2))
                  }
                  
                  // ✅ default
                  else {
                    value = rawValue
                  }

                  if (unit){
                    obj.value = value + ' ' + unit
                    dData.value = value
                    dData.unit = unit
                }else{
                    obj.value = value
                    dData.value = value
                    dData.unit = ''
                }

                obj.time = moment(resp[idx][key].timestamp).format('DD-MM-YYYY  HH:mm:ss')
                dData.time = moment(resp[idx][key].timestamp).format('DD-MM-YYYY  HH:mm:ss')
                if(obj.uid){
                    delete obj.uid 
                }
                window.canData.push(obj)
                window.downloadCanData.push(dData)

            })
        }
        let canData = window.canData
        if (schema.content[0].ref) {
            let sortObj = schema.content[0].ref.refs.table.state.sortBy
            let processed = true
            if(sortObj !== undefined){
                if(!('ascOrder' in sortObj)) {
                    sortObj.ascOrder = true;
                }

                let action = sortObj.ascOrder ? -1 : 1;
                if(sortObj.timestamp) {
                    canData = canData.sort(function(a, b) {
                        return (b[sortObj.timestamp] - a[sortObj.timestamp]) * action;
                    });
                } else if(canData[0]){
                    switch(typeof canData[0][sortObj.key]) {
                        case 'string':
                            canData = canData.sort(function(a, b) {
                                if(a[sortObj.key] < b[sortObj.key]) return -1 * action;
                                if(a[sortObj.key] > b[sortObj.key]) return 1 * action;
                                return 0;
                            });
                            break;
                        default:
                            canData = canData.sort(function(a, b) {
                                return (b[sortObj.key] - a[sortObj.key]) * action;
                            });
                            break;
                    }
                }
            }
            if(sortObj !== undefined){
                schema.content[0].ref.refs.table.setData(canData)
            }else {
                schema.content[0].ref.refs.table.setData(window.canData)

            }
                
        }
        window.setReportWindowTabBusy(schema, false);

    }
}

const schema = {
    key: "can_data_report",
    name: "CAN Data Snapshot",
    toolbar: [
        {
            key: "vehicle",
            type: schemaTypes.MULTI_SELECT,
            singleSelect: true,
            storeData: (state) => {
                return {
                    data: (() => {
                        let newMap = {};
                        for (let idx in state.vehicleMap) {
                            if (idx.indexOf("user") === -1) {
                                newMap[idx] = state.vehicleMap[idx];
                            }
                        }
                        return newMap;
                    })(),
                    name: "vehicleno",
                    id: "vehicleid",
                };
            },
            onItemChange: changeVehicle.bind(this),
            defaultValue: () => {
                return {
                    data: window.selectedVehicles.map((i) => {
                        return i.id;
                    }),
                    updatedAt: window.selectedVehiclesUpdatedAt,
                };
            },
        },
        { key: "get_history", type: schemaTypes.BUTTON, name: "Get Last Snapshot", onClick: getCanDataReport },
        { key: "live_data", type: schemaTypes.SNAPTOGGLE},
        { key: "download", type: schemaTypes.BUTTON, iconType: 'class', icon: 'fa fa-download', onClick: downloadReport },
        { key: "download_select", type: schemaTypes.GROUP_SELECT, iconType: 'class' },
        { key: "get_history", type: schemaTypes.BUTTON, name: "Download", onClick: getAllVehiceData },
    ],
    content: [
        {
            key: 'reportwidget', type: schemaTypes.CANDATA_REPORT,
            position: {
                width: 12,
                height: 12,
                left: 0,
                top: 0
            }
        }
    ]
}
export default schema;